import { SettingsPermissions } from "@redotech/account-common/permissions";
import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import type { OverrideGreenReturnState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const OverrideGreenReturnDetails = memo(
  function OverrideGreenReturnDetails({
    stepSelect,
    state,
    setState,
    flowType,
  }: StepTypeDetailsProps<OverrideGreenReturnState>) {
    const { t } = useTranslation();
    const canEditReturnsSettings = useHasPermission(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    );
    const nextStepChange = useHandler((next: StepId | undefined) => {
      setState((state) => ({ ...state, next }));
    });
    const handleGreenReturn = useHandler((greenReturnOverride: boolean) => {
      setState((state) => ({ ...state, greenReturnOverride }));
    });

    return (
      <>
        <RedoToggle
          description={
            state.greenReturnOverride
              ? t(
                  "Require customer to return item(s),\noverriding by item settings",
                )
              : t(
                  "Allow customer to keep item(s),\noverriding by item settings",
                )
          }
          disabled={!canEditReturnsSettings}
          label={t("Require send back")}
          setValue={handleGreenReturn}
          value={state.greenReturnOverride}
        />
        <Text fontSize="xs" textColor="secondary">
          {t("Next step")}
        </Text>
        {stepSelect({ value: state.next, valueChange: nextStepChange })}
      </>
    );
  },
);
